import { authActions } from "../../../_store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../../_helpers";
import { profileAction } from "../../../_store/myProfile.slice";
import { Link } from "react-router-dom";
import ProfileIcon from "../../../assets/svg/AdminProfile.svg"; // Assuming you have a profile icon SVG
import { showToastNotification } from "../../common/ui/NotificationModal/ToastNotication";
import { Popup } from "../../common/ui/NotificationModal/Popup";
import CustomLoader from "../../common/ui/Loader";
function DropdownProfile() {
  const loggedUser = useSelector((x) => x?.auth?.user);
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL + "/";
  const loggedUserName = sessionStorage?.getItem("loggedUserName");
  const userRoleID = parseInt(sessionStorage?.getItem("userRoleID"));
  const [logoutLoading, setLogoutLoading] = useState(false);
  const dispatch = useDispatch();
  const { getProfileResponse } = useSelector((x) => x?.profile);

  useEffect(() => {
    if (userRoleID) {
      dispatch(profileAction?.getMyProfile());
    }
  }, [dispatch]);

  const handleLogout = (e) => {
    Popup({
      title: "Message",
      text: `Are you sure want to logout?`,
      icon: "question",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        setLogoutLoading(true);
        dispatch(authActions?.logout())
          .then((result) => {
            setLogoutLoading(false);
            if (result?.payload?.status === 1) {
              sessionStorage?.setItem("isLoggedIn", false);
              sessionStorage?.removeItem("userRoleID");
              history?.navigate("/Admin/login");
            } else {
              showToastNotification(result?.error?.message, "error");
            }
          })
          .catch((err) => {
            showToastNotification("Something went wrog", "error");
            setLogoutLoading(false);
          });
      },
    });
  };

  const handleMyProfile = () => {
    history.navigate("/Admin/myProfile");
  };

  const handleChangePassword = () => {
    history.navigate("/Admin/ChangePassword");
  };

  if (logoutLoading) return <CustomLoader />;
  return (
    <div className="navbar-item navbar-user dropdown">
      <a
        href="#/"
        className="navbar-link d-flex align-items-center p-0"
        data-bs-toggle="dropdown"
        aria-label="User profile menu"
      >
        <img
          className="profile-icon"
          src={
            getProfileResponse?.photo
              ? ImageURL + getProfileResponse?.photo
              : ProfileIcon
          }
          alt="User Profile"
        />

        <span>
          <div className="d-flex flex-column">
            <div
              className="d-none d-md-inline fs-5 user-name"
              style={{ color: "#232d42", fontWeight: "400" }}
            >
              {loggedUserName}
              <b className="caret"></b>
            </div>

            <div className="d-none d-md-inline user-role">
              {userRoleID === 3 ? "Super Admin" : "Committee Chair"}
            </div>
          </div>
        </span>
      </a>
      <div className="dropdown-menu dropdown-menu-end me-1">
        <Link
          //  href="#"
          onClick={(e) => {
            e.preventDefault();
          }}
          className="d-md-none fs-5 user-name"
        >
          {loggedUser?.FullName}
        </Link>
        <Link
          //href="#"
          onClick={(e) => {
            e.preventDefault();
          }}
          className="dropdown-item d-md-none fs-5 user-role"
        >
          {loggedUser?.UserRoleName}
        </Link>
        <li className="dropdown-item d-md-none fs-5 border-bottom"></li>
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleMyProfile();
          }}
          className="dropdown-item"
        >
          My Profile
        </Link>

        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleChangePassword();
          }}
          className="dropdown-item"
        >
          Change Password
        </Link>

        <span
          style={{ cursor: "Pointer" }}
          className="dropdown-item"
          onClick={handleLogout}
        >
          logout
        </span>
      </div>
    </div>
  );
}

export default DropdownProfile;
